<template>
  <nav class="navbar is-primary" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/">
        <img src="../assets/logo-horizontal-white.svg" alt="Zegmento" height="38" width="200">
      </router-link>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'Navbar',
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue